import React, { useEffect } from 'react';
import styled from 'styled-components';

import NiceModal from "./NiceModal";

export default function NiceConfirm(props) {
  const {
    onConfirm = () => {

    },
    onCancel = () => {

    },
    canClose = true,
    loading = false,
    confirmText = 'CONFIRM',
    cancelText = 'CANCEL',
    heading = '',
    subHeading = '',

  } = props;

  const handleKeyPress = (evt) => {
    if (evt.keyCode == 27) {
      onCancel();
    }
    if (evt.keyCode == 13) {
      onConfirm();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return (
    <NiceModal canClose={canClose} onClose={() => {
      onCancel();
    }}>

      <DeleteInner>

        {heading == '' ? null :
          <EditInnerHeader>
            {heading}
          </EditInnerHeader>
        }

        {subHeading == '' ? null :
          <SubModalHeading>
            {subHeading}
          </SubModalHeading>
        }

        <DeleteButtonsPlaceholder>
          <DeleteOutlineButton onClick={() => {
            onCancel();
          }}>
            {cancelText}
          </DeleteOutlineButton>
          <DeleteActionButton onClick={async () => {
            onConfirm();
          }}>
            {loading == true ? null :
              confirmText
            }
          </DeleteActionButton>
        </DeleteButtonsPlaceholder>


      </DeleteInner>

    </NiceModal>
  );
}



const SubModalHeading = styled.div`
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.171429px;
  color: #ffffff;
  margin-bottom: 13px;
  font-family: Nunito Sans !Important;
`;


const DeleteOutlineButton = styled.div`
  font-family: Nunito Sans !Important;
  font-weight: bold;
  width: 158px;
  margin: 7px;
  height: 44px;
  border: 1px solid rgba(255, 126, 85, 1);
  color: rgba(255, 126, 85, 1);
  box-sizing: border-box;
  border-radius: 100px;
  font-size: 18px;
  line-height: 15px;
  text-align: center;
  justify-content: center;
  display: flex;
  align-items: center;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;

const DeleteActionButton = styled.div`
  font-family: Nunito Sans !Important;
  margin: 7px;
  width: 158px;
  height: 44px;
  background: rgba(255, 126, 85, 1);
  padding-left: 36px;
  padding-right: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  cursor: pointer;
  border-radius: 1000px;
  font-size: 18px;
  line-height: 15px;
  text-align: center;
  box-shadow: 0px 12px 40px 0px rgba(255, 126, 85, 0.12);

  :hover {
    opacity: 0.8;
  }
`;

const DeleteButtonsPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const DeleteInner = styled.div`
  width: 380px;
  padding: 20px;
  @media (max-width: 540px) {
    width: 100%;
  }
`;

const EditInnerHeader = styled.div`
  text-align: center;
  letter-spacing: 0.166667px;
  color: #ffffff;
  font-size: 24px;
  line-height: 40px;
  //margin-bottom: 29px;
  font-weight: bold;
  font-family: Nunito Sans !Important;
`;
